import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../controls/table/table.jsx';
import { actionCards } from '../../actions/cards_actions.jsx';
import { withTranslation } from 'react-i18next';
import Loader from '../controls/loader/loader.jsx';

const Columns = [
    {
        header: "UserManagement.userName",
        name: "userName"
    },
    {
        header: "UserManagement.firstName",
        name: "firstName"
    },
    {
        header: "UserManagement.secondName",
        name: "secondName"
    },
    {
        header: "UserManagement.email",
        name: "email"
    },
    {
        header: "UserManagement.isActive",
        name: "isActive"
    },
    {
        header: "UserManagement.roleName",
        name: "roleName"
    }
];

class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.getUsers = this.getData.bind(this);
        this.addUser = this.addUser.bind(this);
        this.editUser = this.editUser.bind(this);
    }
    
    componentDidMount() {
        this.getData();
    }

    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getUsers(filter);
    }

    addUser() {
        this.props.history.push('/users/addUser');
    }

    editUser(user) {
        this.props.history.push('/users/editUser/' + user.userId);
    }

    

    render() {
        return (
            <div style={{marginTop: "20px"}}>
                <Table settings={{
                    columns: Columns,
                    items: this.props.users,
                    itemsFilter: this.props.filter,
                    isEditable: true,
                    getItemsFunction: this.getData,
                    addItemFunction: this.addUser,
                    editItemFunction: this.editUser
                }} />
                {this.props.loading && <Loader/>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users.users,
        filter: state.users.filter,
        loading: state.users.loading,
        errors: state.users.errors,
        forceReload: state.users.forceReload
    };
}

export default connect(
        mapStateToProps,
        dispatch => bindActionCreators(actionCards, dispatch)
)(UserList);